import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";

interface UseReviewContactProps {
  contactId?: string
  establishmentLeadId?: string
  state?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: () => void
}

export const useReviewContact = ({ contactId, establishmentLeadId, state, onSuccess, onError }: UseReviewContactProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['reviewContact'],
    mutationFn: (data?: { description?: string }) => {
      const lead = {
        contacts_attributes: [
          {
            id: contactId,
            last_review_attributes: {
              state,
              description: data?.description
            }
          }
        ]
      }

      return privateAxios.putForm(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
